import React from 'react';
import { PencilIcon } from 'lucide-react';
import { ConnectionPageLayout } from '../../components/connections/ConnectionPageLayout';
import { FilterSection } from '../../components/UI/FilterSidebar';
import { OpportunityItem } from '../../components/connections/OpportunityPreviewCard';
import { useDarkClasses } from '../../hooks/useDarkClasses';
import { useRoleTheme } from '../../hooks/useRoleTheme';
const ConnectWithEditors = () => {
  const dk = useDarkClasses();
  const rt = useRoleTheme();
  // Filters
  const filterSections: FilterSection[] = [{
    id: 'sort',
    title: 'Sort By',
    type: 'radio',
    options: [{
      value: 'relevance',
      label: 'Relevance'
    }, {
      value: 'rating-desc',
      label: 'Highest Rated'
    }],
    value: 'relevance',
    onChange: () => {}
  }, {
    id: 'availability',
    title: 'Availability',
    type: 'checkbox',
    options: [{
      value: 'open',
      label: 'Available Now'
    }, {
      value: 'booking',
      label: 'Booking for Q3'
    }],
    value: [],
    onChange: () => {}
  }, {
    id: 'editingType',
    title: 'Editing Type',
    type: 'checkbox',
    options: [{
      value: 'dev',
      label: 'Developmental'
    }, {
      value: 'copy',
      label: 'Copy Editing'
    }, {
      value: 'line',
      label: 'Line Editing'
    }, {
      value: 'proof',
      label: 'Proofreading'
    }],
    value: [],
    onChange: () => {}
  }];
  // Opportunities
  const opportunities: OpportunityItem[] = [{
    id: '1',
    title: 'Developmental Edit for Sci-Fi Novel',
    poster: 'Alex Zhang',
    deadline: '2023-11-25',
    type: 'Fixed Price',
    description: 'Looking for a developmental editor for a 90k word space opera. Focus on pacing and world-building.'
  }, {
    id: '2',
    title: 'Proofreading for Romance Series',
    poster: 'Elena Richards',
    deadline: '2023-12-05',
    type: 'Per Word',
    description: 'Need a proofreader for the final book in a 3-part contemporary romance series.'
  }];
  const formContent = <form className="space-y-6" data-id="element-13824" data-mp="2kt6530s3qfr">
      <div data-id="element-13825" data-mp="2n717bvgl2nb">
        <label className={`block text-sm font-medium ${dk.textSecondary}`} data-id="element-13826" data-mp="31383vblps11c">
          Manuscript Title
        </label>
        <input type="text" className={`mt-1 block w-full rounded-md border shadow-sm focus:outline-none focus:ring-2 px-3 py-2 ${rt.inputFocus} ${dk.inputOnCard}`} data-id="element-13827" data-mp="3619oi0ysg8ex" />
      </div>
      <div data-id="element-13828" data-mp="3g0inj88igd85">
        <label className={`block text-sm font-medium ${dk.textSecondary}`} data-id="element-13829" data-mp="3g10k65z34tgl">
          Genre
        </label>
        <select className={`mt-1 block w-full rounded-md border shadow-sm focus:outline-none focus:ring-2 px-3 py-2 ${rt.inputFocus} ${dk.inputOnCard}`} data-id="element-13830" data-mp="qaf1tghxznj0">
          <option data-id="element-13831" data-mp="2fsbzdlv04zv3">Select a genre</option>
          <option data-id="element-13832" data-mp="2fr9bznww1fjx">Romance</option>
          <option data-id="element-13833" data-mp="2at7rqznq7a6v">Mystery</option>
          <option data-id="element-13834" data-mp="2au0rvhs6j1g1">Fantasy</option>
          <option data-id="element-13835" data-mp="2av2b49jcmu8u">Science Fiction</option>
        </select>
      </div>
      <div data-id="element-13836" data-mp="260y2zmyckg66">
        <label className={`block text-sm font-medium ${dk.textSecondary}`} data-id="element-13837" data-mp="260o9vqi09sw9">
          Word Count
        </label>
        <input type="number" className={`mt-1 block w-full rounded-md border shadow-sm focus:outline-none focus:ring-2 px-3 py-2 ${rt.inputFocus} ${dk.inputOnCard}`} data-id="element-13838" data-mp="21120js5aswsq" />
      </div>
      <div data-id="element-13839" data-mp="1s4ue8968t013">
        <label className={`block text-sm font-medium ${dk.textSecondary}`} data-id="element-13840" data-mp="1n3dg2lf57ro7">
          Type of Editing Needed
        </label>
        <select className={`mt-1 block w-full rounded-md border shadow-sm focus:outline-none focus:ring-2 px-3 py-2 ${rt.inputFocus} ${dk.inputOnCard}`} data-id="element-13841" data-mp="1i53ik45y4ezf">
          <option data-id="element-13842" data-mp="3cibgw5t4r8pt">Select editing type</option>
          <option data-id="element-13843" data-mp="3cjmm8a284oj1">Developmental Editing</option>
          <option data-id="element-13844" data-mp="2a4x5tn0tvafh">Copy Editing</option>
          <option data-id="element-13845" data-mp="2a5yhntpo40y9">Line Editing</option>
          <option data-id="element-13846" data-mp="2a2srsc97sv1h">Proofreading</option>
        </select>
      </div>
      <div data-id="element-13847" data-mp="2e5gyoeedbrvt">
        <label className={`block text-sm font-medium ${dk.textSecondary}`} data-id="element-13848" data-mp="2e5yvbc4y0849">
          Project Description
        </label>
        <textarea rows={4} className={`mt-1 block w-full rounded-md border shadow-sm focus:outline-none focus:ring-2 px-3 py-2 ${rt.inputFocus} ${dk.inputOnCard}`} placeholder="Tell us about your project and what you're looking for in an editor..." data-id="element-13849" data-mp="208tr7hoshjbn" />
      </div>
      <div className="flex justify-end" data-id="element-13850" data-mp="1v9qz0xtwr7l3">
        <button type="submit" className={`px-4 py-2 rounded-md transition-colors text-white ${rt.primaryButton}`} data-id="element-13851" data-mp="1hgrh6p6nl1ad">
          Submit Request
        </button>
      </div>
    </form>;
  return <ConnectionPageLayout title="Connect with Editors" subtitle="Start your editing journey by connecting with our professional editors" icon={<PencilIcon className="h-8 w-8" data-id="element-13853" data-mp="svcz0scokzmo" />} vendorType="editors" filterSections={filterSections} opportunities={opportunities} opportunitiesLink="/services/editing/opportunities" formContent={formContent} formCTALabel="Submit an Editing Request" formCTADescription="Can't find the right editor? Submit your manuscript details and we'll match you." data-id="element-13852" data-mp="17jd48zjxuumt" />;
};
export default ConnectWithEditors;